import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

import { SettingsPage } from "~/components/settings/SettingsPage";
import { useAuthStore } from "~/store/auth-store";

/**
 * The member's e-mail address — read-only.
 *
 * The address *is* the identity: it is what the one-time code is sent to, so changing
 * it means re-verifying the new address before the old one stops working. That flow
 * does not exist yet, so the field is disabled and the screen says why, rather than
 * offering an input that would fail on submit.
 */
export function EmailRoute() {
  const { t } = useTranslation();
  const user = useAuthStore((state) => state.user);

  if (!user) return null;

  return (
    <SettingsPage title={t("profile.email.title")}>
      <TextField
        label={t("profile.email.label")}
        value={user.email}
        disabled
        fullWidth
        slotProps={{
          htmlInput: { "data-testid": "profile.email-value", readOnly: true },
        }}
      />

      <Alert severity="info">{t("profile.email.note")}</Alert>
    </SettingsPage>
  );
}
